/**
 * Theme-independent styles for chat composers (embed + Back Office).
 * Forces a light, readable panel even when the app is in dark mode.
 */

export const CHAT_LIGHT_FIELD_SX = {
  backgroundColor: '#ffffff',
  borderRadius: 2,
  '& .MuiInputBase-root': {
    color: '#212121',
    backgroundColor: '#ffffff',
    fontSize: '0.875rem',
  },
  '& .MuiInputBase-input': {
    color: '#212121 !important',
    WebkitTextFillColor: '#212121',
    caretColor: '#212121',
  },
  '& textarea': {
    color: '#212121 !important',
    WebkitTextFillColor: '#212121',
    caretColor: '#212121',
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#94a3b8',
    opacity: 1,
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: '#94a3b8 !important',
    WebkitTextFillColor: '#94a3b8',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#e2e8f0',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#cbd5e1',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#2563eb',
    borderWidth: 1,
  },
};

export const CHAT_COMPOSER_PANEL_SX = {
  borderTop: '1px solid #e2e8f0',
  backgroundColor: '#ffffff',
  color: '#212121',
};

/** Internal agent notes — soft alert tint (enterprise CS pattern). */
export const CHAT_NOTE_FIELD_SX = {
  backgroundColor: '#fffbeb',
  borderRadius: 2,
  '& .MuiInputBase-root': {
    color: '#78350f',
    backgroundColor: '#fffbeb',
    fontSize: '0.875rem',
  },
  '& .MuiInputBase-input': {
    color: '#78350f !important',
    WebkitTextFillColor: '#78350f',
    caretColor: '#92400e',
  },
  '& textarea': {
    color: '#78350f !important',
    WebkitTextFillColor: '#78350f',
    caretColor: '#92400e',
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#b45309',
    opacity: 1,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#fcd34d',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#f59e0b',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#d97706',
    borderWidth: 1,
  },
};
